import { useParams } from "@cedarjs/router"
import NavSidebar from "src/components/NavSidebar/NavSidebar"

type WrappedLayoutProps = {
  children?: React.ReactNode
}

const WrappedLayout = ({ children }: WrappedLayoutProps) => {
  return (
    <div className="shrink flex justify-center w-full">
      <div className="min-h-screen max-w-1400 w-full px-4">{children}</div>
    </div>
  )
}

export default WrappedLayout
